'use strict';

module.exports = {
    480: require('./480'),
    576: require('./480'),
    720: require('./720'),
    1080: require('./1080')
};
